import React from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";

export default function PrivateRoute({ component: Component, prevLocation, ...rest }) {
    // ROMI-1924 — gate on the cookie-session user, not a localStorage token.
    const { authenticated, current_staff } = useSelector((state) => state.auth);
    return <Route {...rest} render={(props) => (authenticated && current_staff ? <Component {...props} /> : window.location.replace("/login"))} />;
}
